'use strict'

import axios from '@/plugins/axios-instance.js'
import * as type from './types'

// TODO: create gentleFetchVehicles - fetch only if there is an more than N seconds from previous update

const url =
  'https://q53gya9zol.execute-api.eu-west-1.amazonaws.com/prod/vehicles'

const actions = {
  async fetchVehicles ({ commit }) {
    commit(type.REQUEST_LIST_VEHICLES)

    await axios
      .get(url)
      .then(resp => {
        commit(type.REQUEST_LIST_VEHICLES_SUCCESS, {
          payload: resp.data
        })
      })
      .catch(error => {
        commit(type.REQUEST_LIST_VEHICLES_ERROR, {
          error
        })
      })
  },

  async fetchVehicleByID ({ commit }, vehicleID) {
    commit(type.REQUEST_GET_VEHICLE)
    await axios
      .get(`${url}/${vehicleID}`)
      .then(resp => {
        commit(type.REQUEST_GET_VEHICLE_SUCCESS, {
          payload: resp.data
        })
      })
      .catch(error => {
        commit(type.REQUEST_GET_VEHICLE_ERROR, {
          error
        })
      })
  },

  createVehicle ({ commit }, vehicle) {
    commit(type.REQUEST_CREATE_VEHICLE)
    axios
      .post(url, vehicle)
      .then(resp => {
        commit(type.REQUEST_CREATE_VEHICLE_SUCCESS, {
          id: resp.data.id,
          vehicle: vehicle
        })
      })
      .catch(error => {
        commit(type.REQUEST_CREATE_VEHICLE_ERROR, {
          error
        })
      })
  },
  updateVehicle ({ commit }, vehicle) {
    commit(type.REQUEST_UPDATE_VEHICLE)
    axios
      .post(`${url}/${vehicle.id}`, vehicle)
      .then(resp => {
        commit(type.REQUEST_UPDATE_VEHICLE_SUCCESS, {
          id: vehicle.id,
          vehicle: vehicle
        })
      })
      .catch(error => {
        commit(type.REQUEST_UPDATE_VEHICLE_ERROR, {
          error
        })
      })
  },
  deleteVehicle ({ commit }, vehicleID) {
    commit(type.REQUEST_DELETE_VEHICLE)
    axios
      .delete(`${url}/${vehicleID}`)
      .then(resp => {
        commit(type.REQUEST_DELETE_VEHICLE_SUCCESS, {
          vehicleID
        })
      })
      .catch(error => {
        commit(type.REQUEST_DELETE_VEHICLE_ERROR, {
          error
        })
      })
  }
}

export default actions
